<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">

                <reels-form :reel="reel" :loader="loader" @click="storeReel(reel)" :showLabels="false" :showSave="true"></reels-form>

            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import reelsApi from '../../api/reels'
  import reelsForm from './Form.vue'
  import Reel from '../../models/reel'

  export default {

    components: {
      reelsForm
    },
    data () {
      return {
        reel: new Reel(true, undefined, this.$store.state.profile.profile.person.data),
        loader: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Inserisci nuova bobina',
        createButton: {display: false}
      })
      this.$emit('addBackgroundColor', 'rgb(202,94,66)')
    },

    methods: {
      storeReel (reel) {
        this.loader = true
        reelsApi.store(reel)
          .then((response) => {
            toastr.success('La bobina è stata inserita correttamente')
            this.$router.replace({name: 'reelsShow', params: {id: response.data.data.id}})
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/reels/Create.vue